import React, { useMemo, useContext, memo } from 'react'
import { OverlayVehicleContext } from '../../../context.proxies'

import Title from './Title'
import Category from './Category'

const SelectedVehicle = ({
  title,
  changeVehicle,
  isVLP,
  navigateToVLP,
  scrollToDiv,
  linkHeading = 'Parts & Accessories',
  catParts,
  hasBlogs,
  selectedVehicle,
}) => {
  const {
    vehicleImages: { images: vehicleImages, isImagesLoading },
    getFront,
    VEHICLE_IMAGE,
  } = useContext(OverlayVehicleContext)

  const vehicleImage = useMemo(
    () => getFront(vehicleImages, VEHICLE_IMAGE.secureUrl),
    [VEHICLE_IMAGE.secureUrl, getFront, vehicleImages],
  )

  return (
    <>
      <Title
        title={title}
        vehicleImage={vehicleImage}
        isVehicleImageLoading={isImagesLoading}
        selectedVehicle={selectedVehicle}
        isVLP={isVLP}
        changeVehicle={changeVehicle}
        navigateToVLP={navigateToVLP}
      />
      <Category
        scrollToDiv={scrollToDiv}
        linkHeading={linkHeading}
        catParts={catParts}
        isVLP={isVLP}
        hasBlogs={hasBlogs}
      />
    </>
  )
}

export default memo(SelectedVehicle)
